<div class="scanner-overlay">
  <div class="loading">
    <blaze-element-loading-indicator
      [fadeEnabled]="false"
      [isVisible]="!isWebcamOn"
      [mode]="'white'"
      class="loading-indicator"
    />
  </div>

  <div class="header">
    <div class="title">
      @if (!isMultipleCodesDetected) {
        <h1>Scan a Barcode</h1>
      }
    </div>

    @if (isMultipleCodesDetected) {
      <div class="title">
        <h1>Multiple Codes Detected</h1>
        <div class="mt-8">Please choose the correct one</div>
      </div>
      @if (isMultipleCodesDetected) {
        <div class="multiple-codes">
          @for (code of detectedBarcodes; track code) {
            <div (click)="selectValue(code)" class="button found-code">
              <div class="found-code-value" blazeTooltip="{{ code }}">{{ code }}</div>
            </div>
          }
        </div>
      }
    }
  </div>

  <div class="scanner">
    @if (!isMultipleCodesDetected) {
      <webcam
        #webcam
        (imageCapture)="processImage($event)"
        [allowCameraSwitch]="false"
        [trigger]="triggerCapture$$"
        class="webcam"
      />
    }
  </div>

  <div class="footer">
    <div class="close-scanner" (click)="close()">⨉</div>
    @if (isMultipleCodesDetected) {
      <button (click)="resetScanning()" class="button scan-again"> Scan Again </button>
    }
  </div>
</div>
